<template>
  <div>
    <form
      id="mc-embedded-subscribe-form"
      data-v-2ef388bf=""
      action="https://billyrennekamp.us4.list-manage.com/subscribe/post?u=31bb13f30ace8a3f55fd90d3f&amp;id=aea3ef4627"
      method="post"
      name="mc-embedded-subscribe-form"
      target="_blank"
      novalidate="novalidate"
      class="validate">
      <input
        id="mce-EMAIL"
        data-v-2ef388bf=""
        type="email"
        value=""
        name="EMAIL"
        placeholder="Email Address"
        class="mt3 p2 required email green border center">
      <input
        data-v-2ef388bf=""
        type="text"
        name="b_31bb13f30ace8a3f55fd90d3f_aea3ef4627"
        tabindex="-1"
        value=""
        style="display: none;"><input
          id="mc-embedded-subscribe"
          data-v-2ef388bf=""
          type="submit"
          value="Ok"
          name="subscribe"
          class="button border-top border-right border-bottom border-green p2 px3">
    </form>
  </div>
</template>

<script>
export default {

  name: 'NewsletterSignup',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>
